// Unique taglines for every property — no duplicates, no patterns
// Keyed by slug (generated via toFeaturedSlug from display_name)

const TAGLINE_MAP = {
  // === KUMAON ===
  'lands-end': 'At the edge, where the sky opens wide',
  'aarish': 'First light on a Kumaon ridge',
  'meraki': 'Devotion to mountain, forest, and sky',
  'pangot': 'A forest orchestra in five hundred voices',
  'kamet': 'Mornings the peaks compose themselves',
  'white-peaks': 'Heritage orchards under snow-lit horizons',
  'fagunia': 'Leopard country, butterfly garden, stargazer\'s heaven',
  'cliffs-edge': 'Perched where the valley drops away',
  'binsar-wildlife-sanctuary': 'Inside the sanctuary, under the canopy',
  'misty-mountains': 'Above the cloudline, below the stars',
  'raahat': 'Snow peaks in a row, east to west',
  'taradale': 'Literary ghosts among the fruit trees',
  'willows': 'Orchard warmth and the Kumaon range',
  'itmenaan-estate': 'Stone cottages on a six-acre mountainside',
  'fredys-bungalow': 'Antique wood, butterfly walls, lake country',
  'vayu': 'Named for the wind that carries pine',
  'nikka': 'Stillness, orchards, and a veranda facing east',
  'house-on-the-slope': 'Camouflaged in oak at seven thousand feet',
  'himalayan-hidden-house': 'Two rooms on a ridge, nothing else for miles',

  // === HIMACHAL ===
  'sojha': 'Five kilometres past the Jalori Pass, a world apart',
  'annies-song': 'A villa that hums with pine and personality',
  'khaas': 'Kathkuni stone, layered like the centuries',
  'taraview': 'Colonial rooms with original fireplaces and hill weather',
  'bantony-cottage': 'Royal stonework and Sirmur stillness',
  'sangla': 'Borderland peaks and apple orchards at 2,700 metres',
  'glenbrook-castle': 'A stone manor guarding the Seraj Valley',
  'kardhar-project': 'Valley floor, mountain ceiling, paraglider\'s sky',
  'hunzuru': 'Imperfect beauty in the apple orchards of Manali',
  'slow-life': 'Time measured in sunsets, not hours',
  'one-love': 'Tea gardens below, Dhauladhar above',
  'tea-estate': 'Walking the rows where Kangra tea grows',
  'gemoor-khar-jispa': 'A Wazir\'s stone house at three thousand metres',
  'daya-meher': 'Dhauladhar foothills, langur canopy, temple bells',

  // === UTTARAKHAND ===
  'kipling-trail-cottage': 'A private waterfall in the Doon forest',
  'parhawk-estate': 'Sal forest, stream song, Shivalik sky',
  'aashraya': 'Forest above, Ganga below, nothing in between',
  'garhwal': 'Solitude above Mussoorie\'s Mall Road bustle',
  'winterline': 'Seven rooms, a blue roof, and the famous sunset line',
  'wisteria-house': 'Mountain views from every window, firelight within',
  'barefoot-house': 'Slow mornings above the Doon Valley',

  // === KASHMIR ===
  'the-cheese-cottage': 'Walnut trees and wazwan by the Pir Panjal',
  'olive-chalet': 'Snow silence at the gateway to Gulmarg',

  // === TERAI ===
  'ilika': 'Where mountains end and the wide plains begin',

  // === COLLECTIVE PARTNERS ===
  'bluehouse': 'River stones, trout streams, Tirthan soul',
  'eagles-nest': 'Above the valley, inside the forest',
  'eaglenest': 'Above the valley, inside the forest',
  'tra': 'Boutique intimacy in the Kullu heartland',
  'himalayan-homestead': 'Handmade warmth on a Nainital hillside',
  'homestead': 'Handmade warmth on a Nainital hillside',
  'rajucottage': 'Across the river, into the wild',
  'browndipper': 'Where the river bird walks underwater',
  'chirping-chidiya': 'A birdwatcher\'s cottage above the clouds',
  'villaaavaas': 'Four rooms, one valley, and Bobby\'s ten-year promise',
  'villa-aavaas': 'Four rooms, one valley, and Bobby\'s ten-year promise',
  'srirangam': 'Art, Tagore, and Bengali home-cooking in a UNESCO heritage town',
  'srirangam-homestay': 'Art, Tagore, and Bengali home-cooking in a UNESCO heritage town',
};

export default TAGLINE_MAP;
